import { SidebarModalListItem } from '@domain-group/suit-theme'

type SortListItemProps = {
  callbacks: {
    toggleSortItem: (sortItem: string) => void,
  },
  sortItem: string,
}

const SortListItem = (props: SortListItemProps) => {
  const {
    callbacks: {
      toggleSortItem,
    },
    sortItem,
  } = props

  const split = sortItem.split('.')
  const sortDirction = split[1] === 'asc' ? 'ascending' : 'descending'

  return (
    <SidebarModalListItem title={`${split[0]} (${sortDirction})`}>
      {/*
       // @ts-expect-error TS2339 */}
      <SidebarModalListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <SidebarModalListItem.Icon
          onClick={() => toggleSortItem(sortItem)}
          type="delete"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </SidebarModalListItem.Actions>
    </SidebarModalListItem>
  )
}

export default SortListItem
